import type { ReactNode } from "react";

/** The shipment page's icons, lifted from the design prototype (design/account/account.js). */
const Glyph = ({ children, strokeWidth = "1.7" }: { children: ReactNode; strokeWidth?: string }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {children}
  </svg>
);

export const FileIcon = () => (
  <Glyph strokeWidth="1.6">
    <path d="M13.8 3.8H7.6A1.6 1.6 0 0 0 6 5.4v13.2a1.6 1.6 0 0 0 1.6 1.6h8.8a1.6 1.6 0 0 0 1.6-1.6V8.2z" />
    <path d="M13.8 3.8v4.4h4.2" />
  </Glyph>
);

export const EyeIcon = () => (
  <Glyph>
    <path d="M2.6 12S6 6.4 12 6.4 21.4 12 21.4 12 18 17.6 12 17.6 2.6 12 2.6 12z" />
    <circle cx="12" cy="12" r="2.6" />
  </Glyph>
);

export const DownloadIcon = () => (
  <Glyph>
    <path d="M12 4.6v10" />
    <path d="M8.2 11l3.8 3.8L15.8 11" />
    <path d="M5 16.6v2a1.6 1.6 0 0 0 1.6 1.6h10.8a1.6 1.6 0 0 0 1.6-1.6v-2" />
  </Glyph>
);

export const TrashIcon = () => (
  <Glyph>
    <path d="M4.6 7.2h14.8" />
    <path d="M9.4 7.2V5.4a1.2 1.2 0 0 1 1.2-1.2h2.8a1.2 1.2 0 0 1 1.2 1.2v1.8" />
    <path d="M6.6 7.2l.9 11.2a1.6 1.6 0 0 0 1.6 1.4h5.8a1.6 1.6 0 0 0 1.6-1.4l.9-11.2" />
    <path d="M10.4 10.8v5.6M13.6 10.8v5.6" />
  </Glyph>
);

export const UploadIcon = () => (
  <Glyph>
    <path d="M12 15.6V5.2" />
    <path d="M8.2 8.8 12 5l3.8 3.8" />
    <path d="M5 15.8v2.2a1.6 1.6 0 0 0 1.6 1.6h10.8a1.6 1.6 0 0 0 1.6-1.6v-2.2" />
  </Glyph>
);

export const PlusIcon = () => (
  <Glyph strokeWidth="1.8">
    <path d="M12 5.5v13M5.5 12h13" />
  </Glyph>
);

export const CloseIcon = () => (
  <Glyph>
    <path d="M6.4 6.4l11.2 11.2M17.6 6.4 6.4 17.6" />
  </Glyph>
);

/* ---- the Cargo tab's container rows ---- */

export const NotesIcon = () => (
  <Glyph>
    <rect x="5.4" y="4.2" width="13.2" height="15.6" rx="2" />
    <path d="M8.6 9h6.8M8.6 12.4h6.8M8.6 15.8h3.8" />
  </Glyph>
);

export const AttachIcon = () => (
  <Glyph>
    <path d="M15.6 8.2 9 14.8a2.4 2.4 0 0 0 3.4 3.4l6.8-6.8a4 4 0 0 0-5.6-5.6L6.4 12.4a5.6 5.6 0 0 0 7.9 7.9l4.5-4.5" />
  </Glyph>
);

export const AddRowIcon = () => (
  <Glyph strokeWidth="1.8">
    <path d="M12 6.4v11.2M6.4 12h11.2" />
  </Glyph>
);

export const RemoveRowIcon = () => (
  <Glyph strokeWidth="1.8">
    <path d="M6.4 12h11.2" />
  </Glyph>
);
